export default __webpack_public_path__ + "static/jinjibu-banner-60aa5e8e836012e355d84fd650066f67.svg";